import { render, staticRenderFns } from "./PartnerOrder.vue?vue&type=template&id=842642ac"
import script from "./PartnerOrder.vue?vue&type=script&lang=js"
export * from "./PartnerOrder.vue?vue&type=script&lang=js"
import style0 from "./PartnerOrder.vue?vue&type=style&index=0&id=842642ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports